import { Link } from "react-router-dom";
import { LOGO_URL, NAV_LINKS } from "../../lib/landing-data";

const FEATURE_LINKS = [
  { label: "LabelDesk — Label Splitter", to: "/labeldesk" },
  { label: "Price Manager", to: "/price-manager" },
  { label: "Price Reducer", to: "/price-reducer" },
  { label: "Sales Dashboard", to: "/dashboard" },
];

export const Footer = () => {
  return (
    <footer className="relative bg-slate-50 border-t border-purple-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <a href="#home" className="inline-flex">
              <img
                src={LOGO_URL}
                alt="EasyLister · Easy Listings. Sales Growth. Automation."
                className="h-14 sm:h-16 w-auto object-contain"
                draggable="false"
              />
            </a>
            <p className="mt-4 text-sm text-slate-600 leading-relaxed max-w-sm">
              Chrome Extension for Flipkart & Meesho Sellers. AI listings, SEO keywords, live sales dashboard, shipping reducer, clone & auto-fill — all free.
            </p>
            <p className="mt-5 text-xs text-slate-500">
              Made with <span className="text-red-500">♥</span> in India · For Indian Sellers
            </p>
          </div>

          <div>
            <div className="font-heading text-xs font-bold uppercase tracking-wider text-slate-500 mb-4">
              Features
            </div>
            <ul className="space-y-2.5">
              {FEATURE_LINKS.map((f) => (
                <li key={f.to}>
                  <Link to={f.to} className="text-sm text-slate-700 hover:text-purple-700 transition-colors">
                    {f.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-heading text-xs font-bold uppercase tracking-wider text-slate-500 mb-4">
              Navigate
            </div>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-slate-700 hover:text-purple-700 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-purple-100 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} EasyLister. All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="hover:text-purple-700">Privacy</Link>
            <a href="#" className="hover:text-purple-700">Terms</a>
          </div>
        </div>

        <div className="mt-4 text-center text-xs text-slate-400">
          Developed by{" "}
          <a
            href="https://dishant-chudasama.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-slate-500 hover:text-purple-700 transition-colors"
          >
            Dishant Chudasama
          </a>
        </div>
      </div>
    </footer>
  );
};
